
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { StaffXatRankBadge } from '@/components/help-center/equipe-shared';
import { painelSelectTriggerClass } from '@/components/painel/cms/painel-form';
import { painelSelectContentClass } from '@/components/painel/painel-styles';
import {
  STAFF_XAT_RANK_OPTIONS,
  optionIdToXatRank,
  type StaffXatRankOptionId,
} from '@/lib/equipe-xat-ranks';
import { cn } from '@/lib/utils';

type PainelXatRankFieldProps = {
  value: StaffXatRankOptionId | 'none';
  onChange: (value: StaffXatRankOptionId | 'none') => void;
  label?: string;
  hint?: string;
  previewHint?: string;
  className?: string;
  selectContentClassName?: string;
};

export function PainelXatRankField({
  value,
  onChange,
  label = 'Cargo no xat',
  hint = 'Opcional — Volunteer, Wiki Editor, Smiley Maker ou Developer.',
  previewHint = 'Prévia da badge nos artigos e em /equipe',
  className,
  selectContentClassName = painelSelectContentClass,
}: PainelXatRankFieldProps) {
  const previewRank = value !== 'none' ? optionIdToXatRank(value) : null;

  return (
    <div className={cn('grid gap-2', className)}>
      <Label className="font-inter text-xs font-medium text-blue-100/90">{label}</Label>
      <Select value={value} onValueChange={(v) => onChange(v as StaffXatRankOptionId | 'none')}>
        <SelectTrigger className={painelSelectTriggerClass}>
          <SelectValue placeholder="Nenhum" />
        </SelectTrigger>
        <SelectContent position="popper" className={selectContentClassName}>
          <SelectItem value="none" className="focus:bg-white/10 focus:text-white">
            Nenhum
          </SelectItem>
          {STAFF_XAT_RANK_OPTIONS.map((option) => (
            <SelectItem
              key={option.id}
              value={option.id}
              className="focus:bg-white/10 focus:text-white"
            >
              <span className="flex items-center gap-2.5">
                <span
                  className="h-2.5 w-2.5 shrink-0 rounded-full"
                  style={{ backgroundColor: option.rank.color }}
                  aria-hidden
                />
                <span>{option.rank.label}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {previewRank ? (
        <div className="flex flex-wrap items-center gap-2 pt-0.5">
          <StaffXatRankBadge rank={previewRank} />
          <span className="font-inter text-xs text-slate-500">{previewHint}</span>
        </div>
      ) : (
        <p className="font-inter text-xs text-slate-500">{hint}</p>
      )}
    </div>
  );
}
